import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../../ui/card';

const MarketSelection = ({ 
  areas, 
  selectedArea,
  planTypeFilter,
  recentOnlyFilter,
  excludeTrialFilter,
  subscriptions,
  totalCount,
  isLoading,
  onAreaChange,
  onPlanTypeChange,
  onRecentOnlyChange,
  onExcludeTrialChange
}) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle>Market Selection</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label htmlFor="area-select" className="block text-sm font-medium text-gray-700 mb-2">
              Select Market:
            </label>
            <select 
              id="area-select" 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
              onChange={onAreaChange}
              disabled={isLoading}
            >
              <option value="">Choose a market...</option>
              {areas.map(area => (
                <option key={area.id} value={area.id}>{area.name}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Plan Type Filter:
            </label>
            <select 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
              value={planTypeFilter}
              onChange={onPlanTypeChange}
              disabled={isLoading || !selectedArea}
            >
              <option value="">All Plans</option>
              <option value="annual">Annual Only</option>
              <option value="monthly">Monthly Only</option>
              <option value="quarterly">Quarterly Only</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Additional Filters:
            </label>
            <div className="space-y-2">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={recentOnlyFilter}
                  onChange={onRecentOnlyChange}
                  disabled={isLoading || !selectedArea}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-700">Recent only (3mo)</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={excludeTrialFilter}
                  onChange={onExcludeTrialChange}
                  disabled={isLoading || !selectedArea}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-700">Hide trial users</span>
              </label>
            </div>
          </div>
          
          {selectedArea && (
            <div className="flex items-end">
              <div className="text-sm text-gray-600">
                <strong>{subscriptions.length}</strong> of <strong>{totalCount}</strong> subscriptions
                <br />
                <span className="text-xs text-gray-500">in {selectedArea.name}</span>
                {totalCount > 50 && (
                  <div className="text-xs text-orange-600 mt-1">
                    ⚠️ Showing first 50 for performance
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default MarketSelection;